import React from 'react';

import HorizontalNav6 from '../components/horizontal-navs/HorizontalNav6';
import HttpCode2 from '../components/http-codes/HttpCode2';
import Footer2 from '../components/footers/Footer2';

export default function HttpCodes() {
  return (
    <React.Fragment>
      <HorizontalNav6 content={null} />

      <HttpCode2 content={null} />

      <Footer2 content={null} />
    </React.Fragment>
  );
}

